import Vue from "vue";
import solutionguide from "./solutionguide"
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import solutionGuideStore from './store/solutionGuideStore';


export const solutionguideinit = {
    init: () => {
        const solutionguideShells = document.querySelectorAll('.solutionguide');
        solutionguideShells.forEach(shell => {
            const configurationName = shell.dataset.configuration
            if (!configurationName || !window[configurationName] || typeof window[configurationName] !== 'object') {
                return
            }

            solutionGuideStore.commit('init', { segmentData: window[configurationName].segmentData, ctalink: window[configurationName].ctalink })

            Vue.use(Vuex);
            Vue.use(VueI18n);

            new Vue({
                store: solutionGuideStore,
                render: h => h(solutionguide),
                i18n: new VueI18n({
                    locale: 'guide', // set locale
                    messages: window[configurationName].i18n
                }),
            }).$mount(shell);
        });
    }
};
